
import { DashboardHeader } from '../containers/dashboard/DashboardHeader'
import { SidebarProvider } from '../context/SidebarContext'
import { PageWrapper } from '../layouts/components/PageWrapper'
import { Sidebar } from '../layouts/components/Sidebar'
import { Dashboard } from './Dashboard'

export const IndexPage = () => {
  return (
    <SidebarProvider>
      <PageWrapper
        header={<DashboardHeader />}
        sidebar={<Sidebar />}
        mainProps={{ sx: { pt: {base: 2, md: 8} } }}
      >
        <Dashboard />
      </PageWrapper>
    </SidebarProvider>
  )
}